import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { AniSlideUp } from '@/components/shared/animations/basic';

import { useIndustrialFasteningMetrics } from '../useIndustrialPageData';

/**
 * ### IndustrialFasteningMetrics
 *
 * States the published connector engagement figures, each next to the
 * customer, line, and release date it was measured under.
 *
 * Its figures are press-release results while the production figures above it
 * are the press kit's own scoped claims, so each entry names its source in its
 * own scope line, and the values are set smaller than the production ones: the
 * two sets share a page and must not read as one list.
 *
 * @returns The rendered figure list element
 * @see {@link useIndustrialFasteningMetrics} The figures rendered here
 */
export default function IndustrialFasteningMetrics() {
  const { t } = useTranslation('common');
  const metrics = useIndustrialFasteningMetrics(t);

  return (
    <div>
      <h3 className="text-[20px] font-bold leading-[140%] tracking-[-0.4px] text-apps-coreGrayWhite lg:text-[clamp(20px,1.875vw,26px)]">
        {t('체결 검사 지표')}
      </h3>
      <ul className="mt-[24px] flex flex-col gap-[20px] lg:mt-[32px] lg:grid lg:grid-cols-3 lg:gap-[32px]">
        {metrics.map((metric, index) => (
          <AniSlideUp key={metric.label} delay={0.2 * index} element="li">
            <div className="border-t border-t-apps-brandGray50 pt-[20px]">
              <p className="text-[28px] font-bold leading-[120%] tracking-[-0.56px] text-apps-brandGrayWhite lg:text-[clamp(28px,2.222vw,36px)]">
                {metric.value}
              </p>
              <h4 className="mt-[8px] text-[17px] font-bold leading-[140%] tracking-[-0.34px] text-apps-coreGrayWhite lg:text-[19px]">
                {metric.label}
              </h4>
              <p className="mt-[8px] text-[15px] font-medium leading-[150%] tracking-[-0.3px] text-apps-brandGray600 lg:text-[16px] lg:leading-[160%]">
                {metric.scope}
              </p>
            </div>
          </AniSlideUp>
        ))}
      </ul>
    </div>
  );
}
